import React, { useState } from 'react';
import { LockKey } from '@phosphor-icons/react';
import useAuthStore from '../store/authStore';
import { notifySuccess } from '../lib/notify';

const field = 'w-full px-4 py-2.5 border border-[#D5E8E4] rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#00a69c]/40';

export default function ForcePasswordChange() {
  const { changePassword, logout, user } = useAuthStore();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next.length < 8) return setError('New password must be at least 8 characters');
    if (next !== confirmPw) return setError('New passwords do not match');
    if (next === current) return setError('New password must be different from the current one');
    setSaving(true);
    const r = await changePassword(current, next);
    setSaving(false);
    if (r.success) notifySuccess('Password updated. Welcome aboard!');
    else setError(typeof r.error === 'string' ? r.error : 'Could not change password');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F9F7] px-4" data-testid="force-password-change">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-2xl border border-[#D5E8E4] p-8 shadow-sm space-y-4">
        <div className="w-12 h-12 rounded-xl bg-[#E2F3F0] text-[#00a69c] flex items-center justify-center">
          <LockKey size={26} weight="fill" />
        </div>
        <h1 className="text-2xl font-bold text-[#1F3B36]" style={{ fontFamily: 'Outfit' }}>Set your own password</h1>
        <p className="text-sm text-[#3B5A54]">
          Hi {user?.name || 'there'}, your password was set by an administrator. Please choose a new one to continue.
        </p>
        <input type="password" className={field} placeholder="Current (temporary) password" value={current}
          onChange={(e) => setCurrent(e.target.value)} required data-testid="fpc-current-input" />
        <input type="password" className={field} placeholder="New password (min 8 characters)" value={next}
          onChange={(e) => setNext(e.target.value)} required data-testid="fpc-new-input" />
        <input type="password" className={field} placeholder="Confirm new password" value={confirmPw}
          onChange={(e) => setConfirmPw(e.target.value)} required data-testid="fpc-confirm-input" />
        {error && <p className="text-sm text-rose-600" data-testid="fpc-error">{error}</p>}
        <button type="submit" disabled={saving}
          className="w-full py-2.5 rounded-lg bg-[#00a69c] hover:bg-[#008c84] text-white font-semibold text-sm transition-colors disabled:opacity-60"
          data-testid="fpc-submit-btn">
          {saving ? 'Saving…' : 'Save and continue'}
        </button>
        <button type="button" onClick={logout} className="w-full text-sm text-[#3B5A54] hover:underline" data-testid="fpc-logout-btn">
          Log out
        </button>
      </form>
    </div>
  );
}
